// THIS IS DUPLICATED CODE from model/avatar_config.py but till we decide a proper role control for these variables and okay middleground.

export enum AvatarLook {
  Default = "default",
  Victoria = "victoria",
  Cindy = "cindy",
  Sola = "sola",
  Therapist = "therapist",
  Dan = "dan",
  DanCool = "dan_cool",
  DanPerformative = "dan_performative",
  DanTechbro = "dan_techbro",
  Andy = "andy",
  Keith = "keith",
  Anatoly = "anatoly",
  Chanel = "chanel",
  Joya = "joya",
  Mary = "mary",
  Maria = "maria",
  Maggie = "maggie",
}

export enum AvatarVoice {
  Default = "default",
  Ali2 = "ali2",
  Josh = "josh",
  Cindy = "cindy",
  Victoria = "victoria",
  Chad = "chad",
  Tim = "tim",
  Dan = "dan",
  Andy = "andy",
  Keith = "keith",
  Anatoly = "anatoly",
  Joya = "joya",
}

export enum VoicePersonality {
  Default = "default",
  Direct = "direct",
  Fun = "fun",
  DirectValence = "direct_valence",
  Model = "model",
  StayCool = "stay_cool",
  StayWarm = "stay_warm",
  Professional = "professional",
  ProfessionalRecruiter = "professional_recruiter",
  ProfessionalSensitive = "professional_sensitive",
  ProfessionalMedical = "professional_medical",
  Solana = "solana"
}

export enum AvatarEnvironment {
  Default = "default",
  Gameshow = "gameshow",
  LoftMod = "loftmod",
  Solana = "solana",
}

export enum AvatarLocation {
  Default = "default",
  Nook = "nook",
  Couch = "couch",
  LoftMod = "loftmod",
}

export enum AvatarPose {
  Default = "default",
  SitLeft = "sit_left",
  SitRight = "sit_right",
  LeanForward = "lean_forward",
  LeanBack = "lean_back",
}

export enum AvatarShot {
  Default = "default",
  CloseupX = "closeup_x",
  Closeup = "closeup",
  MedCloseup = "med_closeup",
  Med = "med",
  Wide = "wide",
  Ultrawide = "ultrawide",
}

export enum AvatarLanguage {
  Default = "default",
  English = "english",
  Spanish = "spanish",
  French = "french",
  Italian = "italian",
  German = "german",
  Dutch = "dutch",
  Portuguese = "portuguese",
  Latin = "latin",
  Japanese = "japanese",
  Mandarin = "mandarin",
  Hindi = "hindi",
  Hebrew = "hebrew",
  Arabic = "arabic",
  Korean = "korean",
  Polish = "polish",
  Russian = "russian",
  Swedish = "swedish",
  Turkish = "turkish",
}

export enum VoiceEmotion {
  Default = "default",
  Neutral = "neutral",
  Calm = "calm",
  Concerned = "concerned",
  Confused = "confused",
  Empathetic = "empathetic",
  Excited = "excited",
  Interested = "interested",
  Happy = "happy",
  Sad = "sad",
  Angry = "angry",
  Contempt = "contempt",
  Fearful = "fearful",
  Disgusted = "disgusted",
  Surprised = "surprised",
  Warm = "warm",
  Engaging = "engaging",
  Playful = "playful",
  Sarcastic = "sarcastic",
  Mocking = "mocking",
  Bragging = "bragging",
  Confident = "confident",
  Steady = "steady",
  Snarky = "snarky",
  Irritated = "irritated",
  Frustrated = "frustrated",
  Agitated = "agitated",
  Resigned = "resigned",
  Haughty = "haughty",
  Dismissive = "dismissive",
}

export interface AvatarConfig {
  avatar_look?: string;
  avatar_voice?: string;
  avatar_voice_personality?: string;
  avatar_default_emotion?: string;
  avatar_language?: string;
  avatar_location?: string;
  avatar_pose?: string;
  environment?: string;
  shot?: string;
}

// Helper functions for descriptions
export const getAvatarLookDescription = (look?: string): string => {
  switch (look) {
    case AvatarLook.Default:
      return "Default avatar with sleek modern beige blazer and short spiky haircut";
    case AvatarLook.Victoria:
      return "Long blonde hair, wearing a sleek modern beige blazer over a black top";
    case AvatarLook.Cindy:
      return "African American woman with curly hair and confident poise, wearing a sleek modern beige blazer";
    case AvatarLook.Sola:
      return "Solana avatar appearance";
    case AvatarLook.Therapist:
      return "Smart blue sweater, gold moon necklace, and curly blonde/brown hair";
    case AvatarLook.Dan:
      return "(Male) Dan avatar appearance";
    case AvatarLook.DanCool:
      return "(Male) Dan cool avatar appearance";
    case AvatarLook.DanPerformative:
      return "(Male) Dan performative avatar appearance";
    case AvatarLook.DanTechbro:
      return "(Male) Dan techbro avatar appearance";
    case AvatarLook.Andy:
      return "Andy avatar appearance";
    case AvatarLook.Keith:
      return "Keith avatar appearance";
    case AvatarLook.Anatoly:
      return "Anatoly Yakovenko - Solana CEO";
    case AvatarLook.Chanel:
      return "Chanel avatar appearance";
    case AvatarLook.Joya:
      return "Joya avatar appearance";
    case AvatarLook.Mary:
      return "Mary avatar appearance - scrubs";
    case AvatarLook.Maria:
      return "Maria avatar appearance - scrubs with Latin makeup";
    case AvatarLook.Maggie:
      return "Maggie avatar appearance - sweater with Latin makeup";
    default:
      return "Default appearance";
  }
};

export const getAvatarVoiceDescription = (voice?: string): string => {
  switch (voice) {
    case AvatarVoice.Default:
      return "Default voice setting";
    case AvatarVoice.Ali2:
      return "Ali voice variant 2";
    case AvatarVoice.Josh:
      return "Josh voice";
    case AvatarVoice.Cindy:
      return "Cindy voice";
    case AvatarVoice.Victoria:
      return "Victoria voice";
    case AvatarVoice.Chad:
      return "Chad voice";
    case AvatarVoice.Tim:
      return "Tim voice";
    case AvatarVoice.Anatoly:
      return "Anatoly voice";
    case AvatarVoice.Joya:
      return "Joya voice";
    default:
      return "Custom voice setting";
  }
};

export const getVoicePersonalityDescription = (
  personality?: string
): string => {
  switch (personality) {
    case VoicePersonality.Default:
      return "Default personality with standard emotion transitions";
    case VoicePersonality.Direct:
      return "Direct communication without emotion transitions";
    case VoicePersonality.Fun:
      return "Fun personality that communicates with humor and lightheartedness";
    case VoicePersonality.DirectValence:
      return "Direct communication without emotion transitions";
    case VoicePersonality.Model:
      return "Model-driven personality (alias for default)";
    case VoicePersonality.StayCool:
      return "Stay calm, nothing too bombastic, but lean cool";
    case VoicePersonality.StayWarm:
      return "Stay calm, nothing too bombastic, but lean warm";
    case VoicePersonality.Professional:
      return "Generic professional personality";
    case VoicePersonality.ProfessionalRecruiter:
      return "Professional personality for recruiting interactions";
    case VoicePersonality.ProfessionalSensitive:
      return "Professional and sensitive, minimalistic emotional expression";
    case VoicePersonality.ProfessionalMedical:
      return "Professional personality for medical topics";
    case VoicePersonality.Solana:
      return "Professional personality for Solana blockchain discussions with crypto humor";
    default:
      return "Custom personality setting";
  }
};

export const getEnvironmentDescription = (env?: string): string => {
  switch (env) {
    case AvatarEnvironment.Default:
      return "Default environment setting";
    case AvatarEnvironment.Gameshow:
      return "Game show environment with appropriate lighting and backdrop";
    case AvatarEnvironment.LoftMod:
      return "Modern loft environment with contemporary styling";
    default:
      return "Custom environment";
  }
};

export const getAvatarLocationDescription = (location?: string): string => {
  switch (location) {
    case AvatarLocation.Default:
      return "Default location";
    case AvatarLocation.Nook:
      return "Cozy nook setting";
    case AvatarLocation.Couch:
      return "Comfortable couch setting";
    case AvatarLocation.LoftMod:
      return "Modern loft location";
    default:
      return "Custom location";
  }
};

export const getAvatarPoseDescription = (pose?: string): string => {
  switch (pose) {
    case AvatarPose.Default:
      return "Default pose";
    case AvatarPose.SitLeft:
      return "Sitting with left orientation";
    case AvatarPose.SitRight:
      return "Sitting with right orientation";
    case AvatarPose.LeanForward:
      return "Leaning forward engaged pose";
    case AvatarPose.LeanBack:
      return "Relaxed leaning back pose";
    default:
      return "Custom pose";
  }
};

export const getAvatarShotDescription = (shot?: string): string => {
  switch (shot) {
    case AvatarShot.Default:
      return "Default camera shot";
    case AvatarShot.CloseupX:
      return "Extreme close-up shot";
    case AvatarShot.Closeup:
      return "Close-up shot";
    case AvatarShot.MedCloseup:
      return "Medium close-up shot";
    case AvatarShot.Med:
      return "Medium shot";
    case AvatarShot.Wide:
      return "Wide shot";
    case AvatarShot.Ultrawide:
      return "Ultra-wide shot";
    default:
      return "Custom camera shot";
  }
};

export const getAvatarLanguageDescription = (language?: string): string => {
  switch (language) {
    case AvatarLanguage.Default:
      return "Default language (English)";
    case AvatarLanguage.English:
      return "English";
    case AvatarLanguage.Spanish:
      return "Spanish (Español)";
    case AvatarLanguage.French:
      return "French (Français)";
    case AvatarLanguage.Italian:
      return "Italian (Italiano)";
    case AvatarLanguage.German:
      return "German (Deutsch)";
    case AvatarLanguage.Dutch:
      return "Dutch (Nederlands)";
    case AvatarLanguage.Portuguese:
      return "Portuguese (Português)";
    case AvatarLanguage.Latin:
      return "Latin (Latina)";
    case AvatarLanguage.Japanese:
      return "Japanese (日本語)";
    case AvatarLanguage.Mandarin:
      return "Mandarin Chinese (中文)";
    case AvatarLanguage.Hindi:
      return "Hindi (हिन्दी)";
    case AvatarLanguage.Hebrew:
      return "Hebrew (עברית)";
    case AvatarLanguage.Arabic:
      return "Arabic (العربية)";
    case AvatarLanguage.Korean:
      return "Korean (한국어)";
    case AvatarLanguage.Polish:
      return "Polish (Polski)";
    case AvatarLanguage.Russian:
      return "Russian (Русский)";
    case AvatarLanguage.Swedish:
      return "Swedish (Svenska)";
    case AvatarLanguage.Turkish:
      return "Turkish (Türkçe)";
    default:
      return "Custom language";
  }
};

export const getVoiceEmotionDescription = (emotion?: string): string => {
  switch (emotion) {
    case VoiceEmotion.Default:
      return "Default emotion";
    case VoiceEmotion.Neutral:
      return "Neutral - balanced emotional state";
    case VoiceEmotion.Calm:
      return "Calm - peaceful and composed";
    case VoiceEmotion.Concerned:
      return "Concerned - showing worry or care";
    case VoiceEmotion.Confused:
      return "Confused - uncertain or puzzled";
    case VoiceEmotion.Empathetic:
      return "Empathetic - understanding and compassionate";
    case VoiceEmotion.Excited:
      return "Excited - enthusiastic and energetic";
    case VoiceEmotion.Interested:
      return "Interested - curious and engaged";
    case VoiceEmotion.Happy:
      return "Happy - joyful and pleased";
    case VoiceEmotion.Sad:
      return "Sad - sorrowful or melancholic";
    case VoiceEmotion.Angry:
      return "Angry - frustrated or irritated";
    case VoiceEmotion.Contempt:
      return "Contempt - disdainful or scornful";
    case VoiceEmotion.Fearful:
      return "Fearful - anxious or afraid";
    case VoiceEmotion.Disgusted:
      return "Disgusted - repulsed or revolted";
    case VoiceEmotion.Surprised:
      return "Surprised - astonished or startled";
    case VoiceEmotion.Warm:
      return "Warm - friendly and welcoming";
    case VoiceEmotion.Engaging:
      return "Engaging - actively interested and interactive";
    case VoiceEmotion.Playful:
      return "Playful - fun and lighthearted";
    case VoiceEmotion.Sarcastic:
      return "Sarcastic - ironic or mocking tone";
    case VoiceEmotion.Mocking:
      return "Mocking - teasing or ridiculing";
    case VoiceEmotion.Bragging:
      return "Bragging - boastful and proud";
    case VoiceEmotion.Confident:
      return "Confident - self-assured and certain";
    case VoiceEmotion.Steady:
      return "Steady - stable and grounded";
    case VoiceEmotion.Snarky:
      return "Snarky - sharply critical or cutting";
    case VoiceEmotion.Irritated:
      return "Irritated - mildly annoyed";
    case VoiceEmotion.Frustrated:
      return "Frustrated - feeling blocked or hindered";
    case VoiceEmotion.Agitated:
      return "Agitated - restless and upset";
    case VoiceEmotion.Resigned:
      return "Resigned - accepting with reluctance";
    case VoiceEmotion.Haughty:
      return "Haughty - arrogantly superior";
    case VoiceEmotion.Dismissive:
      return "Dismissive - treating as unworthy of consideration";
    default:
      return "Custom emotion";
  }
};
